
import { getAuthService } from '../../apps/auth/service'
import { Component, Vue } from 'vue-property-decorator'
import { v4 as uuid4 } from 'uuid'
import { AuthMachineInterpreter } from '../../apps/auth/authMachine'

@Component
export default class GoogleLoginButton extends Vue {
  authMachine: AuthMachineInterpreter

  // different buttonId for every instance of that component
  buttonId = `google-sign-in-button-${uuid4()}`

  async mounted() {
    this.authMachine = await getAuthService()
    const locale = this.$i18n.locale ? this.$i18n.locale.split('-')[0] : 'en'

    await this.$loadScriptWithPromise(
      `//accounts.google.com/gsi/client?hl=${locale}`,
      'googleLogin',
    )

    google.accounts.id.initialize({
      client_id: this.$config.public.googleApiKey,
      callback: this.initialiseCallback,
    })

    google.accounts.id.renderButton(
      document.getElementById(this.buttonId) as HTMLElement,
      {
        type: 'standard',
        theme: 'filled_blue',
        size: 'large',
      },
    )
  }

  private async initialiseCallback(initialiseVal: any) {
    this.authMachine.send('LOG_IN_GOOGLE', {
      token: initialiseVal.credential,
    })
  }

  beforeDestroy() {
    this.$unloadScript('googleLogin')
  }
}
